module.exports = __webpack_public_path__ + "static/media/Moj-9.9b9e03d8.PNG";